import 'rxjs/add/observable/from';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';
import type { Location, RouterActionPush } from '@atlassian/react-resource-router';
import { addSelectedIssueToUrl } from '../../services/routing/selected-issue-url-change/index.tsx';
import {
	type ParentClick,
	PARENT_CLICK,
	cardSingleSelect,
} from '../../state/actions/cards/selection/index.tsx';
import { openDetailView } from '../../state/actions/detail-view/index.tsx';
import { getIssueParents } from '../../state/selectors/issue-parent/index.tsx';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types.tsx';

export const selectIssueParentEpic =
	(getLocation: () => Location, push: RouterActionPush) =>
	(action$: ActionsObservable, store: MiddlewareAPI) =>
		action$.ofType(PARENT_CLICK).mergeMap((action: ParentClick) => {
			const state = store.getState();
			const { cardId } = action.payload;
			const issueParents = getIssueParents(state);
			const parentCardId = issueParents[String(cardId)] ? issueParents[String(cardId)].key : null;

			if (!parentCardId) {
				return Observable.empty<never>();
			}

			const actions = [cardSingleSelect(cardId), openDetailView(cardId)];
			push(addSelectedIssueToUrl(parentCardId, getLocation()));

			return Observable.from(actions);
		});
